export default __webpack_public_path__ + "static/media/110t.7159146f.jpg";